import {AnimatedSprite, Container, isMobile, Sprite, Texture} from "pixi.js";
import {spriteSheetAssets} from "./spriteSheetAssets";
import * as PIXI from "pixi.js";
import {gsap} from "gsap";
import {pixiComponents} from "../index";
import {rocketExplosionSound, rocketLaunchSound} from "../soundService";
import {calculateDistance} from "../utilites";
import {getStores} from "./spin";

export class TotalMultiplier {
    container = new Container();
    bgSprite = new Sprite(Texture.from('./assets/total-multiplier-bg.webp'));
    title = new PIXI.Text("TOTAL", totalMultiplierTitleTextStyle);
    title2 = new PIXI.Text("MULTIPLIER", totalMultiplierTitleTextStyle);
    text = new PIXI.Text('11x', totalMultiplierNumberTextStyle);
    totalMultiplier = 0;
    targetPosition = {x: 750, y: 0};

    constructor() {
        this.container.addChild(this.bgSprite, this.title, this.title2, this.text);
        this.container.alpha = 0;
        this.setPositions();
        this.setTotalMultiplier(0);
    }

    updatePositionAndScale() {
        if (!isMobile.phone) {
            this.container.position.set(70, 35);
            this.targetPosition = {x: 750, y: 0};
            return;
        }
        if (getStores().store.isHorizontalScreen) {
            this.container.position.set(45, 40);
            this.container.scale.set(0.75);
            this.targetPosition = {x: 650, y: -5};
        } else {
            this.container.position.set(215, 520);
            this.container.scale.set(0.9);
            this.targetPosition = {x: 170, y: -520};
        }
    }

    setPositions() {
        this.bgSprite.position.set(0, 40);
        this.title.anchor.set(0.5, 0);
        this.title2.anchor.set(0.5, 0);
        this.title.position.set(this.bgSprite.width / 2, 25);
        this.title2.position.set(this.bgSprite.width / 2, 53);
        this.text.anchor.set(0.5);
        this.text.position.set(this.bgSprite.width / 2, 125);
        this.container.position.set(70, 35);
    }

    setTransparency(alpha) {
        gsap.to(this.container,
            {alpha: alpha})
    }

    setTotalMultiplier(num) {
        this.text.position.set(this.bgSprite.width / 2, 125);
        this.totalMultiplier = num;
        this.text.text = num + 'x';

        if (num === 0) {
            this.text.alpha = 0.45;
        } else {
            this.text.alpha = 1;
        }

        gsap.to(this.text.scale, {
            x: 1.1,
            y: 1.1,
            duration: 0.25,
            yoyo: true,
            repeat: 1,
        })
    }

    async totalMultiplierAnimationToTumbleBoard() {
        await gsap.to(this.text.position, {
            x: this.targetPosition.x,
            y: this.targetPosition.y,
            duration: 0.75,
            ease: 'none',
        });
    }
}

export class MultipliersBoard {
    container = new Container();
    multiplierIcons = [];
    totalMultiplayerComponent = new TotalMultiplier();

    constructor() {
    }

    requireMultiplierIcon(num, reelSymbol) {
        let selectedIcon = null;

        for (let i = 0; i < this.multiplierIcons.length; i++) {
            if (this.multiplierIcons[i].isFree) {
                selectedIcon = this.multiplierIcons[i];
            }
        }

        if (!selectedIcon) {
            selectedIcon = new MultiplierIcon();
            this.multiplierIcons.push(selectedIcon);
            this.container.addChild(selectedIcon.container);
        }

        selectedIcon.initialize(num, reelSymbol);
    }

    async explosion() {
        this.multiplierIcons.sort((icon1, icon2) => icon1.container.x - icon2.container.x);

        return new Promise(async (resolve) => {
            for (let i = 0; i < this.multiplierIcons.length; i++) {
                if (!this.multiplierIcons[i].isFree) {
                    console.log(i)
                    await this.multiplierIcons[i].explosion();
                    console.log(i)
                }
            }
            resolve();
        })
    }

    clean() {
        for (let i = 0; i < this.multiplierIcons.length; i++) {
            this.multiplierIcons[i].clean();
            this.multiplierIcons[i].stopFollowingReelSymbol();
        }
    }

}

export class MultiplierIcon {
    isFree = true;
    container = new Container();
    bookAnimatedSprite = new AnimatedSprite(spriteSheetAssets.magicBall.animations['animation']);
    text = new PIXI.Text(`180X`, {...textStyle});
    reelSymbol = null;
    multiplier = 0;

    constructor() {
        this.container.addChild(this.bookAnimatedSprite);
        this.container.addChild(this.text);

        this.text.anchor.set(0.5);
        this.text.position.x = this.bookAnimatedSprite.width * 0.5;
        this.text.position.y = this.bookAnimatedSprite.height * 0.5;

        this.container.pivot.x = this.bookAnimatedSprite.width * 0.5;
        this.container.pivot.y = this.bookAnimatedSprite.height * 0.5;

        this.container.x = 400;
        this.container.y = 400;

        this.bookAnimatedSprite.animationSpeed = 0.75;
    }

    playFlightSpriteSheet() {
        rocketLaunchSound.play();
        this.bookAnimatedSprite.loop = false;
        this.bookAnimatedSprite.textures = spriteSheetAssets.magicBall.animations['animation'];
        this.bookAnimatedSprite.play();
    }

    setDefaultSprite() {
        this.bookAnimatedSprite.loop = false;
        this.bookAnimatedSprite.textures = spriteSheetAssets.magicBall.animations['animation'];
    }

    updatePositionByReelSymbol() {
        this.container.x = this.reelSymbol.parentReel.container.x;
        this.container.y = this.reelSymbol.animatedSprite.y;
    }

    startFollowingReelSymbol() {
        pixiComponents.app.ticker.add(this.updatePositionByReelSymbol, this);
    }

    stopFollowingReelSymbol() {
        pixiComponents.app.ticker.remove(this.updatePositionByReelSymbol, this);
    }

    initialize(num, reelSymbol) {
        this.isFree = false;
        this.reelSymbol = reelSymbol;
        this.text.text = num + "X";
        this.multiplier = num;
        this.container.rotation = 0;
        this.text.alpha = 1;
        this.bookAnimatedSprite.alpha = 1;
        this.startFollowingReelSymbol();
        this.setDefaultSprite();
        this.text.position.x = this.bookAnimatedSprite.width * 0.5;
        this.text.position.y = this.bookAnimatedSprite.height * 0.54
        this.text.style.fontSize = 60;
    }

    clean() {
        this.isFree = true;
        this.bookAnimatedSprite.alpha = 0;
        this.text.alpha = 0;
        this.setDefaultSprite();
    }

    async explosion() {
        rocketExplosionSound.play();
        await gsap.to(this.container.scale, {
            x: 1.1,
            y: 1.1,
            yoyo: true,
            repeat: 1,
            duration: 0.15,
        })
        return new Promise(async (resolve) => {
            this.playFlightSpriteSheet();
            const duration = Math.min(0.9, (calculateDistance(this.container.position, targetCoords) + 300) / 1000);
            gsap.to(this.text.position, {
                x: targetCoords.x - this.container.position.x,
                y: targetCoords.y - this.container.position.y,
                duration,
                ease: "power1.in",
            });

            await gsap.to(this.text.style, {
                fontSize: 39,
                duration,
                ease: "power1.in",
            });

            this.text.alpha = 0;
            pixiComponents.slotBoard.tumbleWinBoard.addMultiplayer(this.multiplier);
            this.isFree = true;

            await gsap.delayedCall(0.1, () => {
            });
            resolve();
        })
    }

}

const textStyle = new PIXI.TextStyle({
    align: 'center',
    fontFamily: 'BebasNeue',
    fontWeight: 900,
    fill: ['#f5c013', '#f59b13'],
    stroke: '#a65400',
    strokeThickness: 3,
    dropShadow: true,
    dropShadowColor: '#a65800',
    dropShadowBlur: 2,
    dropShadowDistance: 0,
    fontSize: 60,
});

const totalMultiplierTitleTextStyle = new PIXI.TextStyle({
    fontFamily: 'BebasNeue',
    fontWeight: 900,
    fill: ['#f5c013', '#f59b13'],
    stroke: '#a65400',
    strokeThickness: 3,
    fontSize: 31,
    align: 'center',
    lineHeight: 26,
    dropShadow: true,
    dropShadowColor: '#a65800',
    dropShadowBlur: 2,
    dropShadowDistance: 0,
});

const totalMultiplierNumberTextStyle = new PIXI.TextStyle({
    fontFamily: 'BebasNeue',
    fontWeight: 900,
    fill: ['#f5c013', '#f59b13'],
    stroke: '#a65400',
    strokeThickness: 3,
    fontSize: 69,
    align: 'center',
    dropShadow: true,
    dropShadowColor: '#a65800',
    dropShadowBlur: 2,
    dropShadowDistance: 0,
});

const targetCoords = {x: 580, y: 50}